import { withSuspense } from 'components/Decorators';
import { lazy } from 'react';
import Fallback from './YoutubeVideo.fallback';

export default withSuspense(
  lazy(() => import('./YoutubeVideo')),
  Fallback,
);
